export const AUTH_TOKEN_KEY = "token"
export const USER_PROFILE_KEY = "user"
export const BOOKING_APP_AUTH_TOKEN_KEY = "booking_app_auth_token"
export const BOOKING_APP_USER_PROFILE_KEY = "booking_app_user"
